var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 1.8457,
    y: 1.36133,
    width: 40.9419,
    height: 40.9419,
    rx: 6.63923,
    fill: "#6F7CED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7618 21.8321C25.1035 21.8321 27.8126 19.1231 27.8126 15.7813C27.8126 12.4395 25.1035 9.73047 21.7618 9.73047C18.42 9.73047 15.7109 12.4395 15.7109 15.7813C15.7109 19.1231 18.42 21.8321 21.7618 21.8321Z",
    fill: "#6F7CED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7618 23.8496C16.7514 23.8552 12.6911 27.9155 12.6855 32.9258C12.6855 33.4828 13.137 33.9343 13.694 33.9343H29.8295C30.3865 33.9343 30.8379 33.4828 30.8379 32.9258C30.8324 27.9155 26.7721 23.8551 21.7618 23.8496Z",
    fill: "#6F7CED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDark);
export default __webpack_public_path__ + "static/media/user-dark.f769d2ac.svg";
export { ForwardRef as ReactComponent };